import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useQuery, useMutation } from "react-query";
import { GetCacheKey } from "../../services/common/utils";
import Loadingcomponent from "../../components/loader/loadingcomponent";
import ErrorMessage from "../../components/messaging/errormessage";
import SpecialDealsDetailBanner from "../../components/special-deals/special-deals-detail-banner";
import SpecialDealsCard from "../../components/special-deals/special-deals-card";
import { SPECIAL_DEALS_OFFER_ACTIVATE } from "../../services/common/endpoints";
import { callQueryapi } from "../../services/http/callapi";
import {
  RecordScreenEvent,
  RecordlogEvents,
} from "../../../src/analytics/RecordEvents";
import {GTMScreenView, GTM_View_Item} from '../../../src/analytics/GoogleTagManager'
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import SpecialDealsPostPaidCards from '../../components/special-deals/postpaid-special-deals-cards';
import {CT_Events} from "../../analytics/CTEvents";
import OfferDetail from "../../components/loader/skeletons/common/offer-detail";

const SelectedComponentDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const params = useParams();
  const {CT_ProductViewed} = CT_Events();
  const userdata = useSelector(
    (state) => state?.userdata?.value?.rnuserdetails
  );
  const [clickedOffer, setClickedOfferData] = useState([]);
  const [otherOffer, setOtherOfferData] = useState([])
  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const msisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
  useEffect(() => {
    try {
      RecordScreenEvent("SpecialDealsProductDetail", logintype, userdata);
    } catch (e) {}
    try{
      GTMScreenView("SpecialDealsProductDetail", msisdn, logintype)
    }catch{}
  }, []);
  const {
    data: { data } = {},
    isLoading,
    error,
    isFetching,
    isError,
    isLoadingError,
  } = useQuery(
    [
      GetCacheKey("special-deails-details"),
      location?.state?.psmItem?.method,
      JSON.parse(location?.state?.psmItem?.sourceid),
      {},
    ],
    {
      retry: false,
      retryOnMount: false,
      cacheTime: 0,
      staleTime: 0,
    }
  );
  const activateOffer = useMutation(
    (req) =>
      callQueryapi({
        queryKey: [{}, SPECIAL_DEALS_OFFER_ACTIVATE, req],
      }),
    {
      onSuccess: async (udata) => {
        try {
          try {
            PostpaidCVMEventCT("Success", udata?.data?.message);
          } catch (e) {}
          navigate("/transaction-status", {
            state: {
              info_message: udata?.data?.infomsg,
              message: udata?.data?.message,
              status: udata?.data?.status,
            },
          });
        } catch (e) {}
      },
      onError: (uerror) => {
        try {
          PostpaidCVMEventCT("Failure", uerror?.data?.message);
        } catch (e) {}
      },
    }
  );

  const toggleModal = () => {
    navigate("/special-deals-pay", {
        state: { data: clickedOffer, msisdn: location?.state?.msisdn, offerCode: clickedOffer?.offercode, psmItem: location?.state?.psmItem, flag: location?.state?.specialOfferFlagActive },
      });
  };

  useEffect( ()=>{
      let tempArray =[]
      if(location?.state?.specialOfferFlagActive === true){
        data?.response?.AvailableOffers?.map(
          (offer) =>{ 
            if(offer?.offercode == params?.offerCode) {
               setClickedOfferData(offer)
               try{
                 GTM_View_Item(offer, "SpecialDeals_Postpaid");
                 CT_ProductViewed(offer, "SpecialDeals_Postpaid");
               }catch{}
            }else{
              tempArray.push(offer)
            }}
        );
      }
      else{
        data?.response?.filter(item => item?.msisdn === location?.state?.msisdn)?.map(obj => obj?.AvailableOffers?.map(
          (offer) => {
          if(offer?.offercode == params?.offerCode){
            setClickedOfferData(offer);
            try{
              GTM_View_Item(offer, "SpecialDeals_Postpaid");
              CT_ProductViewed(offer, "SpecialDeals_Postpaid")
            }catch{}
          }else{
            tempArray.push(offer)
          }}
        ));
      }

      setOtherOfferData(tempArray)
      
  }, [data, location])
  
//   useEffect( ()=>{
//     data?.response?.filter(item => item?.msisdn === location?.state?.msisdn)?.map(obj => obj?.AvailableOffers?.filter(
//       (offer) => offer?.offerid == location?.state?.offerid ? setClickedOfferData(offer) : ''
//     ));
//     console.log(clickedOffer)
    
// }, [ location])
  
  const PostpaidCVMEventCT = (statusType, statusdesription) => {
    try {
      RecordlogEvents("Postpaid CVM", {
        "Mobile Number": userdata?.msisdn,
        "Offer type": clickedOffer?.servicetype,
        "Offer Category": clickedOffer?.category,
        "Offer Subcategory": clickedOffer?.subcategory,
        "Price": clickedOffer?.amount,
        "Offer details": clickedOffer?.title,
        "status": statusType,
        "Status Description": statusdesription,
        "Offer availability": "Offer available",
      });
    } catch (e) {}
  };

  const handleContinueClick = (e) => {
    e.preventDefault();

    const offerData = {
      offerid: clickedOffer?.offerid,
      action: "ACCEPT",
      price: clickedOffer?.amount,
      packprice: clickedOffer?.amount,
    };

    activateOffer.mutate(offerData);
  };

  if (isLoading || isFetching) {
    // return <Loadingcomponent message={"Loading"} />;
    return <OfferDetail longOfferCard={true} bannerHeight="210px" />
  }

  if (error || isError || isLoadingError) {
    return <ErrorMessage message={"Invalid"} />;
  }

  return (
    <div className="pse_sm">
      <SpecialDealsDetailBanner data={clickedOffer} />

      <div className="buy_card flex_grp_align_center">
        <div className="buy_card_info flex_grp_align_center flex1">
          <h3 className="section_title primary_color mb-0">
            {clickedOffer?.currency || ""} {clickedOffer?.amount || ""}
          </h3>
        </div>
        <div className="buy_card_action">
          <button
            className="custom_btn custom_btn_primary"
            onClick={toggleModal}
          >
            {clickedOffer?.actionbutton}
          </button>
        </div>
      </div>

      <h3 className="section_title mb-4">{clickedOffer?.title}</h3>
      <h5 className="primary_14 text-uppercase mb-2">{t("details")}</h5>
      <p className="dark_gray_color mb-3 formated-desc">{clickedOffer?.description}</p>

      {/* {clickedOffer?.fifa && (
        <div className="blue_detail_card">
          EARN 5 CHANCES TO WIN TICKETS TO FIFA WORLD CUP QATAR 2022
        </div>
      )} */}

      {otherOffer?.length >= 1 && (
        <>
          <hr className="hr_line"></hr>
          <h3 className="section_title_light mb-4 mt-4">{t("umaylike")}</h3>

          {otherOffer?.slice(0,3).map((offer) => {
            return (
              <div className="mb-3">
                <SpecialDealsPostPaidCards
                  offerItem={offer}
                  msisdn={location?.state?.msisdn}
                  psmItem={location?.state?.psmItem}
                  flag={location?.state?.specialOfferFlagActive}
                />
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};
export default SelectedComponentDetails;
